<script setup lang="ts">
import {
  ArticleItem,
  BlogArticleProps,
  TransformedArticle,
  articleTransformer,
  sortArticles,
} from '~/components/cms/BlogArticlePanel/blogArticleHelper'

const props = defineProps<BlogArticleProps>()
const { blogArticles, supportingData, connectedContentPillar, title } = props
const { getEntries } = useContentful()
const url = `/connected/${connectedContentPillar?.fields?.slug}`
const categoryToSearch = connectedContentPillar?.fields?.category
const isSortByPublishedDateDesc = supportingData?.home?.Algorithm?.value === 'publishDateDesc'
const orderFilter = isSortByPublishedDateDesc ? { order: '-fields.publishedDate' } : {}
const articles = ref<TransformedArticle[]>([])

if (blogArticles && blogArticles.length) {
  const transformedArticles = articleTransformer(blogArticles)
  articles.value = isSortByPublishedDateDesc ? sortArticles(transformedArticles) : transformedArticles
} else {
  const { data } = await useAsyncData(`BlogArticleList:${categoryToSearch}`, async () => {
    const entries = await getEntries({
      content_type: 'blogArticle',
      'fields.category': categoryToSearch,
      ...orderFilter,
      limit: 8,
    })
    if (!entries || !entries.items) {
      return undefined
    }
    return entries.items
  })
  articles.value = articleTransformer(data.value as ArticleItem[])
}
</script>

<template>
  <section class="blog-article-list">
    <h3 class="blog-article-list__title">{{ title }}</h3>
    <div class="blog-article-list__view-all">
      <Anchor :href="url">
        {{ $t('blog_article_list.view_all') }}
      </Anchor>
    </div>
    <div class="swiper-container">
      <Carousel :items="articles">
        <template #swiperSlide="{ item }">
          <ArticleCard variant="article-list" :item="item" />
        </template>
      </Carousel>
    </div>
  </section>
</template>
<style lang="postcss">
.blog-article-list {
  max-width: 80rem;
  margin: 0 auto;
  padding: var(--space-50);
  text-align: center;

  .blog-article-list__title {
    font-size: var(--text-xlarge);
    margin-bottom: 0;
  }

  .blog-article-list__view-all {
    margin-top: var(--space-20);
    margin-bottom: var(--space-90);
  }
}
</style>
